import Utils from '../../../utils/util';

// todo: 阅读性较差，需要优化
function layoutSplit(layerChildrenCoordinate: CubePaintCoordinate[], totalWidth: number): CubePaintCoordinate[] {
    let result: CubePaintCoordinate[] = [];

    for (let i = 0; i < layerChildrenCoordinate.length; i++) {
        let prev: CubePaintCoordinate = layerChildrenCoordinate[i - 1];
        let now: CubePaintCoordinate = layerChildrenCoordinate[i];
        let rightLine: number = Utils.math(now.left, now.width, '+');
        let halfNow: number = Utils.math(now.width, 2, '/');
        let next: CubePaintCoordinate = layerChildrenCoordinate[i + 1];
        let leftSpaceWidth: number = 0;
        let rightSpaceWidth: number = 0;

        if (i === 0) {
            leftSpaceWidth = Utils.math(now.left, 2, '*');
        }
        else {
            leftSpaceWidth = Utils.math(now.left, Utils.math(prev.left, prev.width, '+'), '-');
        }

        if (i === layerChildrenCoordinate.length - 1) {
            rightSpaceWidth = Utils.math(totalWidth, rightLine, '-');
            rightSpaceWidth = Utils.math(rightSpaceWidth, 2, '*');
        }
        else {
            rightSpaceWidth = Utils.math(next.left, rightLine, '-');
        }

        let halfLeftSpaceWidth: number = Utils.math(leftSpaceWidth, 2, '/');
        let halfRightSpaceWidth: number = Utils.math(rightSpaceWidth, 2, '/');
        let leftValue: number = Utils.math(now.left, halfLeftSpaceWidth, '-');

        let leftArea: CubePaintCoordinate = {
            id: now.id,
            left: leftValue,
            top: now.top,
            width: Utils.math(Utils.math(now.left, halfNow, '+'), leftValue, '-'),
            height: now.height
        };
        let rightArea: CubePaintCoordinate = {
            id: now.id,
            left: Utils.math(leftArea.left, leftArea.width, '+'),
            top: now.top,
            width: Utils.math(halfRightSpaceWidth, halfNow, '+'),
            height: now.height
        };

        result.push(leftArea);
        result.push(rightArea);
    }

    return result;
}

export {
    layoutSplit
};
